const PARAGRAPH = /<p>([\s\S]*?)<\/p>/gi
// An icon set into a sentence (`data-inline`) is an inline node, so it stays.
const BLOCK_IMAGE = "<img(?![^>]*\\sdata-inline\\b)[^>]*>"
// A bare image, or an anchor wrapping one. The anchor lifts out whole so
// schemas with an inline image keep the link instead of dropping the image.
const BLOCK_UNIT = new RegExp(
	`(<a[^>]*>(?:(?!<\\/a>)[\\s\\S])*?${BLOCK_IMAGE}[\\s\\S]*?<\\/a>|${BLOCK_IMAGE})`,
	"i",
)
const BLOCK_UNIT_ONLY = new RegExp(`^${BLOCK_UNIT.source}$`, "i")
const HAS_BLOCK_IMAGE = new RegExp(BLOCK_IMAGE, "i")

// Our image node is block-level and ProseMirror drops a block nested in a
// paragraph, so every markdown converter's <p><img></p> loses the image.
export function unwrapBlockImages(html: string): string {
	return html.replace(PARAGRAPH, (paragraph, inner: string) => {
		if (!HAS_BLOCK_IMAGE.test(inner)) return paragraph
		return inner
			.split(BLOCK_UNIT)
			.map((part) => {
				if (BLOCK_UNIT_ONLY.test(part)) return part
				const text = part.replace(/<br\s*\/?>/gi, "").trim()
				return text ? `<p>${text}</p>` : ""
			})
			.join("")
	})
}
